function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.array.flat-map.js";
import "core-js/modules/es.array.unscopables.flat-map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.values.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { z } from 'zod';

// eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: try to fix this any.  We may be able to straight up remove ZodObject in the future

/**
 * Creates an array schema given a specific item schema, while also using
 * z.preprocess to filter out unrecognized data before validation.  This means
 * the array can contain extra data if the "type" attribute is not recognized.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any -- This any is necessary to allow for any type to be passed in
export function arrayFilterOutUnrecognized(schema) {
  if (!Array.isArray(schema.options)) {
    throw new Error('arrayFilterOutUnrecognized only works with discriminated unions');
  }
  var types = schema.options.flatMap(function (option) {
    if (!option || _typeof(option) !== 'object') {
      return [];
    }
    if (!('shape' in option) || !option.shape || _typeof(option.shape) !== 'object') {
      return [];
    }
    if (!('type' in option.shape) || !option.shape.type || _typeof(option.shape.type) !== 'object') {
      return [];
    }
    if ('enum' in option.shape.type && _typeof(option.shape.type["enum"]) === 'object' && option.shape.type["enum"]) {
      return Object.values(option.shape.type["enum"]);
    }
    if ('Values' in option.shape.type && _typeof(option.shape.type.Values) === 'object' && option.shape.type.Values) {
      return Object.values(option.shape.type.Values);
    }
    if ('value' in option.shape.type && typeof option.shape.type.value === 'string') {
      return option.shape.type.value;
    }
    return [];
  });
  return z.preprocess(function (data) {
    if (!Array.isArray(data)) {
      return data;
    }

    // Filter out the types that we don't use, before we validate the data
    return data.filter(function (item) {
      if (_typeof(item) === 'object' && item && 'type' in item) {
        return types.includes(item.type);
      }
      return true;
    });
  }, z.array(schema));
}